export const standaloneComposerPath = '/compose';

export enum StandaloneComposerStatusEnum {
  /* Draft is good for the user to edit */
  VALID_DRAFT = 'valid-draft',
  /* Something is wrong with the draft */
  INVALID_DRAFT = 'invalid-draft',
  SENT = 'sent',
  SENDING = 'sending',
  /* Draft was shared and the user is no longer the author  */
  NOT_AUTHOR_SHARED = 'not-author-shared',
  DELETED = 'deleted-draft',
}
